<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="B2546, B2650, M1246, MS521 &eacute;s MS621 nyomtat&oacute;">
     B2546, B2650, M1246, MS521 &eacute;s MS621 nyomtat&oacute;
    </a>
   </p>
   <p class="toc-1-style">
    <a href="safety.html#safety_hu" title="Biztons&aacute;gi inform&aacute;ci&oacute;k">
     Biztons&aacute;gi inform&aacute;ci&oacute;k
    </a>
   </p>
   <div id="divd0e18">
    <p class="toc-2-style">
     <a href=".html#d0e23" title="Konvenci&oacute;k">
      Konvenci&oacute;k
     </a>
    </p>
    <p class="toc-2-style">
     <a href="safety-power-cord-topic.html#d0e42" title="Term&eacute;knyilatkozatok">
      Term&eacute;knyilatkozatok
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="learning-about-printer-chapter.html#learning-about-printer-chapter_hu" title="Inform&aacute;ci&oacute;k a nyomtat&oacute;r&oacute;l">
     Inform&aacute;ci&oacute;k a nyomtat&oacute;r&oacute;l
    </a>
   </p>
   <div id="divd0e179">
    <p class="toc-2-style">
     <a href="finding-information-about-printer-topic.html#finding-information-about-printer_hu" title="Tov&aacute;bbi inform&aacute;ci&oacute;k a nyomtat&oacute;r&oacute;l">
      Tov&aacute;bbi inform&aacute;ci&oacute;k a nyomtat&oacute;r&oacute;l
     </a>
    </p>
    <p class="toc-2-style">
     <a href="selecting-location-printer-m-topic.html#selecting-location-printer-m_hu" title="A nyomtat&oacute; hely&eacute;nek kiv&aacute;laszt&aacute;sa">
      A nyomtat&oacute; hely&eacute;nek kiv&aacute;laszt&aacute;sa
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-configurations-topic.html#printer-configurations_hu" title="Nyomtat&oacute;be&aacute;ll&iacute;t&aacute;sok">
      Nyomtat&oacute;be&aacute;ll&iacute;t&aacute;sok
     </a>
    </p>
    <p class="toc-2-style">
     <a href="attaching-cables-topic.html#attaching-cables_hu" title="A k&aacute;belek csatlakoztat&aacute;sa">
      A k&aacute;belek csatlakoztat&aacute;sa
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-control-panel-topic.html#using-control-panel_hu" title="A kezelőpanel haszn&aacute;lata">
      A kezelőpanel haszn&aacute;lata
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-status-of-power-button-and-indicator-light-topic.html#understanding-status-of-power-button-and-indicator-light_hu" title="A bekapcsol&oacute;gomb &eacute;s jelzőf&eacute;ny &aacute;llapot&aacute;nak jelent&eacute;sei">
      A bekapcsol&oacute;gomb &eacute;s jelzőf&eacute;ny &aacute;llapot&aacute;nak jelent&eacute;sei
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="loading-paper-and-specialty-media-chapter.html#loading-paper-and-specialty-media-chapter_hu" title="Pap&iacute;r &eacute;s speci&aacute;lis hordoz&oacute; bet&ouml;lt&eacute;se">
     Pap&iacute;r &eacute;s speci&aacute;lis hordoz&oacute; bet&ouml;lt&eacute;se
    </a>
   </p>
   <div id="divd0e735">
    <p class="toc-2-style">
     <a href="setting-size-and-type-of-specialty-media-topic.html#setting-size-and-type-of-specialty-media_hu" title="Speci&aacute;lis hordoz&oacute; m&eacute;ret&eacute;nek &eacute;s t&iacute;pus&aacute;nak megad&aacute;sa">
      Speci&aacute;lis hordoz&oacute; m&eacute;ret&eacute;nek &eacute;s t&iacute;pus&aacute;nak megad&aacute;sa
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-universal-paper-settings-h1-topic.html#configuring-universal-paper-settings-h1_hu" title="Az Univerz&aacute;lis pap&iacute;rbe&aacute;ll&iacute;t&aacute;sok konfigur&aacute;l&aacute;sa">
      Az Univerz&aacute;lis pap&iacute;rbe&aacute;ll&iacute;t&aacute;sok konfigur&aacute;l&aacute;sa
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-trays-topic.html#loading-trays_hu" title="T&aacute;lc&aacute;k bet&ouml;lt&eacute;se">
      T&aacute;lc&aacute;k bet&ouml;lt&eacute;se
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-multipurpose-feeder-topic.html#loading-multipurpose-feeder_hu" title="A t&ouml;bbc&eacute;l&uacute; adagol&oacute; bet&ouml;lt&eacute;se">
      A t&ouml;bbc&eacute;l&uacute; adagol&oacute; bet&ouml;lt&eacute;se
     </a>
    </p>
    <p class="toc-2-style">
     <a href="linking-and-unlinking-trays-topic.html#linking-and-unlinking-trays_hu" title="T&aacute;lc&aacute;k &ouml;sszekapcsol&aacute;sa">
      T&aacute;lc&aacute;k &ouml;sszekapcsol&aacute;sa
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="supported-paper-sizes-types-and-weights-chapter.html#supported-paper-sizes-types-and-weights-chapter_hu" title="Pap&iacute;rtart&oacute;">
     Pap&iacute;rtart&oacute;
    </a>
   </p>
   <div id="divd0e933">
    <p class="toc-2-style">
     <a href="supported-paper-sizes-gsm-topic.html#supported-paper-sizes-gsm_hu" title="T&aacute;mogatott pap&iacute;rm&eacute;retek">
      T&aacute;mogatott pap&iacute;rm&eacute;retek
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-paper-types-gold-topic.html#supported-paper-types-gold_hu" title="T&aacute;mogatott pap&iacute;rt&iacute;pusok">
      T&aacute;mogatott pap&iacute;rt&iacute;pusok
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-paper-weights-gsm-topic.html#supported-paper-weights-gsm_hu" title="T&aacute;mogatott pap&iacute;rs&uacute;lyok">
      T&aacute;mogatott pap&iacute;rs&uacute;lyok
     </a>
    </p>
    <p class="toc-2-style">
     <a href="unacceptable-paper-topic.html#unacceptable-paper_hu" title="Nem t&aacute;mogatott pap&iacute;r">
      Nem t&aacute;mogatott pap&iacute;r
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-recycled-paper-topic.html#using-recycled-paper_hu" title="&Uacute;jrahasznos&iacute;tott pap&iacute;r haszn&aacute;lata">
      &Uacute;jrahasznos&iacute;tott pap&iacute;r haszn&aacute;lata
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="printing-chapter.html#printing-chapter_hu" title="Nyomtat&aacute;s">
     Nyomtat&aacute;s
    </a>
   </p>
   <div id="divd0e1540">
    <p class="toc-2-style">
     <a href="printing-from-computer-h2-topic.html#printing-from-computer-h2_hu" title="Nyomtat&aacute;s a sz&aacute;m&iacute;t&oacute;g&eacute;pről">
      Nyomtat&aacute;s a sz&aacute;m&iacute;t&oacute;g&eacute;pről
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-mobile-device-using-lexmark-print-topic.html#d0e1566" title="Nyomtat&aacute;s mobileszk&ouml;zről">
      Nyomtat&aacute;s mobileszk&ouml;zről
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-flash-drive-topic.html#printing-from-flash-drive_hu" title="Nyomtat&aacute;s flash-meghajt&oacute;r&oacute;l">
      Nyomtat&aacute;s flash-meghajt&oacute;r&oacute;l
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-flash-drives-and-file-types-topic.html#supported-flash-drives-and-file-types_hu" title="T&aacute;mogatott flash-meghajt&oacute;k &eacute;s f&aacute;jlt&iacute;pusok">
      T&aacute;mogatott flash-meghajt&oacute;k &eacute;s f&aacute;jlt&iacute;pusok
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-font-sample-list-h2-topic.html#printing-font-sample-list-h2_hu" title="Betűt&iacute;pusmint&aacute;k list&aacute;j&aacute;nak nyomtat&aacute;sa">
      Betűt&iacute;pusmint&aacute;k list&aacute;j&aacute;nak nyomtat&aacute;sa
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-directory-list-h2-topic.html#printing-directory-list-h2_hu" title="K&ouml;nyvt&aacute;rlista nyomtat&aacute;sa">
      K&ouml;nyvt&aacute;rlista nyomtat&aacute;sa
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="understanding-printer-menus-chapter.html#understanding-printer-menus-chapter_hu" title="A nyomtat&oacute; men&uuml;inek ismertet&eacute;se">
     A nyomtat&oacute; men&uuml;inek ismertet&eacute;se
    </a>
   </p>
   <div id="divd0e1825">
    <p class="toc-2-style">
     <a href="menus-map-topic.html#menus-map_hu" title="Men&uuml;t&eacute;rk&eacute;p">
      Men&uuml;t&eacute;rk&eacute;p
     </a>
    </p>
    <p class="toc-2-style">
     <a href="preferences-topic.html#d0e2054" title="Eszk&ouml;z">
      Eszk&ouml;z
     </a>
    </p>
    <p class="toc-2-style">
     <a href="layout-topic.html#d0e3222" title="Nyomtat&aacute;s">
      Nyomtat&aacute;s
     </a>
    </p>
    <p class="toc-2-style">
     <a href="tray-configuration-topic.html#d0e4184" title="Pap&iacute;r">
      Pap&iacute;r
     </a>
    </p>
    <p class="toc-2-style">
     <a href="network-overview-topic.html#d0e4418" title="H&aacute;l&oacute;zat/portok">
      H&aacute;l&oacute;zat/portok
     </a>
    </p>
    <p class="toc-2-style">
     <a href="flash-drive-print-topic.html#d0e5977" title="USB-meghajt&oacute;">
      USB-meghajt&oacute;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="security-audit-log-topic.html#d0e6140" title="Biztons&aacute;g">
      Biztons&aacute;g
     </a>
    </p>
    <p class="toc-2-style">
     <a href="menu-settings-page-topic.html#d0e6632" title="Jelent&eacute;sek">
      Jelent&eacute;sek
     </a>
    </p>
    <p class="toc-2-style">
     <a href="help-topic.html#help_hu" title="S&uacute;g&oacute;">
      S&uacute;g&oacute;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="troubleshooting-menu-topic.html#d0e6816" title="Hibaelh&aacute;r&iacute;t&aacute;s">
      Hibaelh&aacute;r&iacute;t&aacute;s
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-menu-settings-page-h1-topic.html#printing-menu-settings-page-h1_hu" title="Men&uuml;be&aacute;ll&iacute;t&aacute;sok oldal nyomtat&aacute;sa">
      Men&uuml;be&aacute;ll&iacute;t&aacute;sok oldal nyomtat&aacute;sa
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="securing-the-printer.html#securing-the-printer_hu" title="A nyomtat&oacute; biztons&aacute;ga">
     A nyomtat&oacute; biztons&aacute;ga
    </a>
   </p>
   <div id="divd0e6874">
    <p class="toc-2-style">
     <a href="locating-security-slot-topic.html#locating-security-slot_hu" title="Biztons&aacute;gi ny&iacute;l&aacute;s poz&iacute;ci&oacute;ja">
      Biztons&aacute;gi ny&iacute;l&aacute;s poz&iacute;ci&oacute;ja
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-memory-topic.html#erasing-printer-memory_hu" title="Nyomtat&oacute;mem&oacute;ria t&ouml;rl&eacute;se">
      Nyomtat&oacute;mem&oacute;ria t&ouml;rl&eacute;se
     </a>
    </p>
    <p class="toc-2-style">
     <a href="restoring-factory-default-settings-topic.html#restoring-factory-default-settings_hu" title="Gy&aacute;ri alap&eacute;rtelmezett &eacute;rt&eacute;kek vissza&aacute;ll&iacute;t&aacute;sa">
      Gy&aacute;ri alap&eacute;rtelmezett &eacute;rt&eacute;kek vissza&aacute;ll&iacute;t&aacute;sa
     </a>
    </p>
    <p class="toc-2-style">
     <a href="statement-of-volatility-h2-topic.html#statement-of-volatility-h2_hu" title="T&ouml;r&ouml;lhetős&eacute;gi nyilatkozat">
      T&ouml;r&ouml;lhetős&eacute;gi nyilatkozat
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintain-printer-chapter.html#maintain-printer-chapter_hu" title="A nyomtat&oacute; karbantart&aacute;sa">
     A nyomtat&oacute; karbantart&aacute;sa
    </a>
   </p>
   <div id="divd0e7042">
    <p class="toc-2-style">
     <a href="connecting-printer-to-wireless-network-topic.html#d0e7047" title="H&aacute;l&oacute;zat">
      H&aacute;l&oacute;zat
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cleaning-printer-topic.html#cleaning-printer_hu" title="A nyomtat&oacute; tiszt&iacute;t&aacute;sa">
      A nyomtat&oacute; tiszt&iacute;t&aacute;sa
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ordering-supplies-group.html#ordering-supplies-group_hu" title="Alkatr&eacute;szek &eacute;s kell&eacute;kanyagok rendel&eacute;se">
      Alkatr&eacute;szek &eacute;s kell&eacute;kanyagok rendel&eacute;se
     </a>
    </p>
    <p class="toc-2-style">
     <a href="replacing-toner-cartridge-topic.html#d0e7788" title="Alkatr&eacute;szek &eacute;s kell&eacute;kanyagok cser&eacute;je">
      Alkatr&eacute;szek &eacute;s kell&eacute;kanyagok cser&eacute;je
     </a>
    </p>
    <p class="toc-2-style">
     <a href="moving-the-printer-group.html#d0e7932" title="A nyomtat&oacute; &aacute;thelyez&eacute;se">
      A nyomtat&oacute; &aacute;thelyez&eacute;se
     </a>
    </p>
    <p class="toc-2-style">
     <a href="saving-energy-paper.html#d0e7987" title="Energia- &eacute;s pap&iacute;rtakar&eacute;koss&aacute;g">
      Energia- &eacute;s pap&iacute;rtakar&eacute;koss&aacute;g
     </a>
    </p>
    <p class="toc-2-style">
     <a href="recycling.html#d0e8113" title="&Uacute;jrahasznos&iacute;t&aacute;s">
      &Uacute;jrahasznos&iacute;t&aacute;s
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="clearing-jams-chapter.html#clearing-jams-chapter_hu" title="Elakad&aacute;sok megsz&uuml;ntet&eacute;se">
     Elakad&aacute;sok megsz&uuml;ntet&eacute;se
    </a>
   </p>
   <div id="divd0e8167">
    <p class="toc-2-style">
     <a href="avoiding-jams-topic.html#avoiding-jams_hu" title="Pap&iacute;relakad&aacute;sok elker&uuml;l&eacute;se">
      Pap&iacute;relakad&aacute;sok elker&uuml;l&eacute;se
     </a>
    </p>
    <p class="toc-2-style">
     <a href="identifying-jam-locations-topic.html#identifying-jam-locations_hu" title="Elakad&aacute;s hely&eacute;nek azonos&iacute;t&aacute;sa">
      Elakad&aacute;s hely&eacute;nek azonos&iacute;t&aacute;sa
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-door-a-topic.html#paper-jam-in-front-door_hu" title="Pap&iacute;relakad&aacute;s az A ajt&oacute;n&aacute;l">
      Pap&iacute;relakad&aacute;s az A ajt&oacute;n&aacute;l
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-rear-door-topic.html#paper-jam-in-rear-door_hu" title="Pap&iacute;relakad&aacute;s a h&aacute;ts&oacute; ajt&oacute;n&aacute;l">
      Pap&iacute;relakad&aacute;s a h&aacute;ts&oacute; ajt&oacute;n&aacute;l
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-standard-bin-topic.html#paper-jam-in-standard-bin_hu" title="Pap&iacute;relakad&aacute;s a norm&aacute;l t&aacute;rol&oacute;ban">
      Pap&iacute;relakad&aacute;s a norm&aacute;l t&aacute;rol&oacute;ban
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-duplex-unit-topic.html#paper-jam-in-duplex-unit_hu" title="Pap&iacute;relakad&aacute;s a duplex egys&eacute;gben">
      Pap&iacute;relakad&aacute;s a duplex egys&eacute;gben
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-paper-jam-trays-topic.html#message-paper-jam-trays_hu" title="Pap&iacute;relakad&aacute;s a t&aacute;lc&aacute;kban">
      Pap&iacute;relakad&aacute;s a t&aacute;lc&aacute;kban
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-paper-jam-mpf-topic.html#message-paper-jam-mpf_hu" title="Pap&iacute;relakad&aacute;s a t&ouml;bbc&eacute;l&uacute; adagol&oacute;ban">
      Pap&iacute;relakad&aacute;s a t&ouml;bbc&eacute;l&uacute; adagol&oacute;ban
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshooting-chapter.html#troubleshooting-chapter_hu" title="Hibaelh&aacute;r&iacute;t&aacute;s">
     Hibaelh&aacute;r&iacute;t&aacute;s
    </a>
   </p>
   <div id="divd0e8443">
    <p class="toc-2-style">
     <a href="trb-cannot-open-embedded-web-server-topic.html#d0e8446" title="H&aacute;l&oacute;zatikapcsolat-hiba">
      H&aacute;l&oacute;zatikapcsolat-hiba
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-replace-cartridge-printer-region-mismatch-topic.html#d0e8700" title="Kell&eacute;kanyagokkal kapcsolatos probl&eacute;m&aacute;k">
      Kell&eacute;kanyagokkal kapcsolatos probl&eacute;m&aacute;k
     </a>
    </p>
    <p class="toc-2-style">
     <a href="solving-printer-problems.html#solving-printer-problems_hu" title="Pap&iacute;radagol&aacute;si probl&eacute;m&aacute;k">
      Pap&iacute;radagol&aacute;si probl&eacute;m&aacute;k
     </a>
    </p>
    <p class="toc-2-style">
     <a href="solving-printing-problems.html#solving-printing-problems_hu" title="Nyomtat&aacute;si probl&eacute;m&aacute;k">
      Nyomtat&aacute;si probl&eacute;m&aacute;k
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-contacting-customer-support-topic.html#trb-contacting-customer-support_hu" title="Kapcsolatba l&eacute;p&eacute;s az &uuml;gyf&eacute;lszolg&aacute;lattal">
      Kapcsolatba l&eacute;p&eacute;s az &uuml;gyf&eacute;lszolg&aacute;lattal
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="upgrading-migrating-chapter.html#upgrading-migrating-chapter_hu" title="Fejleszt&eacute;s &eacute;s &aacute;thelyez&eacute;s">
     Fejleszt&eacute;s &eacute;s &aacute;thelyez&eacute;s
    </a>
   </p>
   <div id="divd0e11615">
    <p class="toc-2-style">
     <a href="available-internal-options-topic.html#d0e11618" title="Hardver">
      Hardver
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-printer-software-topic.html#d0e11807" title="Szoftver">
      Szoftver
     </a>
    </p>
    <p class="toc-2-style">
     <a href="exporting-importing-configuration-using-ews-winners-circle-topic.html#d0e11883" title="Firmware">
      Firmware
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="laser_ug_notices.html#laser_ug_notices_hu" title="Figyelmeztet&eacute;sek">
     Figyelmeztet&eacute;sek
    </a>
   </p>
   <div id="divd0e11952">
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e11955" title="Term&eacute;kismertető">
      Term&eacute;kismertető
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e11972" title="Kiad&aacute;si megjegyz&eacute;s">
      Kiad&aacute;si megjegyz&eacute;s
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#trademarks_hu" title="V&eacute;djegyek">
      V&eacute;djegyek
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#licensing-notices_hu" title="Licencnyilatkozat">
      Licencnyilatkozat
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#noise-emission-levels_hu" title="Zajkibocs&aacute;t&aacute;si szintek">
      Zajkibocs&aacute;t&aacute;si szintek
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#weee-directive_hu" title="Az elektromos &eacute;s elektronikus term&eacute;kekből keletkező hullad&eacute;kokra vonatkoz&oacute; (WEEE) direkt&iacute;va">
      Az elektromos &eacute;s elektronikus term&eacute;kekből keletkező hullad&eacute;kokra vonatkoz&oacute; (WEEE) direkt&iacute;va
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e12074" title="Environmental labeling for packaging">
      Environmental labeling for packaging
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#product-disposal_hu" title="A term&eacute;k kidob&aacute;sa">
      A term&eacute;k kidob&aacute;sa
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e12108" title="&Uacute;jrat&ouml;lthető l&iacute;tium-ion elem">
      &Uacute;jrat&ouml;lthető l&iacute;tium-ion elem
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#eu-battery-directive-2023-1542_hu" title="(EU) 2023/1542 rendelet">
      (EU) 2023/1542 rendelet
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#returning-lexmark-cartridges-for-reuse-or-recycling_hu" title="A Lexmark fest&eacute;kkazett&aacute;k visszajuttat&aacute;sa &uacute;jb&oacute;li felhaszn&aacute;l&aacute;sra vagy &uacute;jrahasznos&iacute;t&aacute;sra">
      A Lexmark fest&eacute;kkazett&aacute;k visszajuttat&aacute;sa &uacute;jb&oacute;li felhaszn&aacute;l&aacute;sra vagy &uacute;jrahasznos&iacute;t&aacute;sra
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#static-sensitivity-notice_hu" title="Statikus &eacute;rz&eacute;kenys&eacute;ggel kapcsolatos figyelmeztet&eacute;s">
      Statikus &eacute;rz&eacute;kenys&eacute;ggel kapcsolatos figyelmeztet&eacute;s
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#energy-star_hu" title="ENERGY STAR">
      ENERGY STAR
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#temperature-information_hu" title="Hőm&eacute;rs&eacute;kletadatok">
      Hőm&eacute;rs&eacute;kletadatok
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#laser-notice_hu" title="Megjegyz&eacute;s a l&eacute;zerrel kapcsolatban">
      Megjegyz&eacute;s a l&eacute;zerrel kapcsolatban
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#power-consumption_hu" title="Energiafelhaszn&aacute;l&aacute;s">
      Energiafelhaszn&aacute;l&aacute;s
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e12348" title="A vezet&eacute;k n&eacute;lk&uuml;li term&eacute;kekre vonatkoz&oacute; szab&aacute;lyok">
      A vezet&eacute;k n&eacute;lk&uuml;li term&eacute;kekre vonatkoz&oacute; szab&aacute;lyok
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#modular-component-notice_hu" title="Megjegyz&eacute;s a modul&aacute;ris &ouml;sszetevőkről">
      Megjegyz&eacute;s a modul&aacute;ris &ouml;sszetevőkről
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#exposure-to-radio-frequency-radiation_hu" title="A r&aacute;di&oacute;frekvenci&aacute;s sug&aacute;rz&aacute;s hat&aacute;sa">
      A r&aacute;di&oacute;frekvenci&aacute;s sug&aacute;rz&aacute;s hat&aacute;sa
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#european-community-ec-directives-conformity-class-b_hu" title="Az Eur&oacute;pai K&ouml;z&ouml;ss&eacute;g (EK) elő&iacute;r&aacute;sainak val&oacute; megfelel&eacute;s">
      Az Eur&oacute;pai K&ouml;z&ouml;ss&eacute;g (EK) elő&iacute;r&aacute;sainak val&oacute; megfelel&eacute;s
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e12382" title="Az Eur&oacute;pai K&ouml;z&ouml;ss&eacute;g (EK) elő&iacute;r&aacute;sainak val&oacute; megfelel&eacute;s">
      Az Eur&oacute;pai K&ouml;z&ouml;ss&eacute;g (EK) elő&iacute;r&aacute;sainak val&oacute; megfelel&eacute;s
     </a>
    </p>
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue